/**
 * Mock Blog API
 * Simulates backend API for blog posts
 */

// Import existing images
import blogimg from '../assets/images/blogimg.png';
import ftrdClgImg from '../assets/images/ftrdClgImgPlaceholder.png';
import testimonial1 from '../assets/images/testimonial1.jpg';
import testimonial2 from '../assets/images/testimonial2.jpg';
import testimonial3 from '../assets/images/testimonial3.jpg';
import testimonial4 from '../assets/images/testimonial4.png';
import searchHeroBg from '../assets/images/searchHeroBg.png';
import adBanner from '../assets/images/adBanner.png';

// Create array of available images to distribute across blogs
const BLOG_IMAGES = [
  blogimg,
  ftrdClgImg,
  testimonial1,
  testimonial2,
  testimonial3,
  testimonial4,
  searchHeroBg,
  adBanner
];

// Mock blog database
const MOCK_BLOGS = [
  {
    id: 1,
    title: "Top 10 Engineering Colleges in India 2024",
    slug: "top-10-engineering-colleges-india-2024",
    excerpt: "Discover the best engineering colleges in India based on NIRF rankings, placements, and infrastructure.",
    content: "Engineering education in India has evolved significantly over the years. Here are the top 10 engineering colleges that stand out for their academic excellence, research facilities, and placement records...",
    author: "Priya Sharma",
    authorImage: "/images/authors/priya.jpg",
    date: "2024-12-15",
    category: "Engineering",
    tags: ["Engineering", "IIT", "NIT", "Rankings"],
    image: "/images/blogs/engineering-colleges.jpg",
    readTime: "8 min read",
    views: 1250,
    featured: true
  },
  {
    id: 2,
    title: "NEET 2024: Complete Preparation Guide",
    slug: "neet-2024-preparation-guide",
    excerpt: "A comprehensive guide to crack NEET 2024 with study tips, resources, and exam strategies.",
    content: "NEET is one of the most competitive medical entrance exams in India. This guide will help you prepare effectively with proven strategies and resources...",
    author: "Dr. Rajesh Kumar",
    authorImage: "/images/authors/rajesh.jpg",
    date: "2024-12-12",
    category: "Medical",
    tags: ["NEET", "Medical", "Entrance Exam", "Preparation"],
    image: "/images/blogs/neet-preparation.jpg",
    readTime: "12 min read",
    views: 2340,
    featured: true
  },
  {
    id: 3,
    title: "MBA vs MS: Which is Right for You?",
    slug: "mba-vs-ms-which-is-right",
    excerpt: "Compare MBA and MS programs to make an informed decision about your postgraduate education.",
    content: "Choosing between MBA and MS is a crucial decision that can shape your career. Let's compare both programs in terms of curriculum, career prospects, and ROI...",
    author: "Amit Patel",
    authorImage: "/images/authors/amit.jpg",
    date: "2024-12-10",
    category: "MBA",
    tags: ["MBA", "MS", "Career", "Postgraduate"],
    image: "/images/blogs/mba-vs-ms.jpg",
    readTime: "10 min read",
    views: 1890,
    featured: true
  },
  {
    id: 4,
    title: "How to Choose the Right College: A Complete Guide",
    slug: "how-to-choose-right-college",
    excerpt: "Essential factors to consider when selecting a college for your higher education.",
    content: "Choosing the right college is one of the most important decisions of your life. Here are the key factors you should consider...",
    author: "Sneha Reddy",
    authorImage: "/images/authors/sneha.jpg",
    date: "2024-12-08",
    category: "Career Guidance",
    tags: ["College Selection", "Career", "Education"],
    image: "/images/blogs/choose-college.jpg",
    readTime: "7 min read",
    views: 980,
    featured: false
  },
  {
    id: 5,
    title: "JEE Main 2024: Exam Pattern and Syllabus",
    slug: "jee-main-2024-pattern-syllabus",
    excerpt: "Complete breakdown of JEE Main 2024 exam pattern, syllabus, and preparation strategy.",
    content: "JEE Main is the gateway to premier engineering colleges in India. Understanding the exam pattern and syllabus is crucial for success...",
    author: "Vikram Singh",
    authorImage: "/images/authors/vikram.jpg",
    date: "2024-12-05",
    category: "Engineering",
    tags: ["JEE Main", "Engineering", "Entrance Exam"],
    image: "/images/blogs/jee-main.jpg",
    readTime: "9 min read",
    views: 1560,
    featured: false
  },
  {
    id: 6,
    title: "Study Abroad: Top Destinations for Indian Students",
    slug: "study-abroad-top-destinations",
    excerpt: "Explore the best countries for Indian students to pursue higher education abroad.",
    content: "Studying abroad offers global exposure and better career opportunities. Here are the top destinations for Indian students...",
    author: "Neha Gupta",
    authorImage: "/images/authors/neha.jpg",
    date: "2024-12-03",
    category: "Study Abroad",
    tags: ["Study Abroad", "International Education", "Career"],
    image: "/images/blogs/study-abroad.jpg",
    readTime: "11 min read",
    views: 2100,
    featured: false
  },
  {
    id: 7,
    title: "Scholarship Opportunities for Engineering Students",
    slug: "scholarship-opportunities-engineering",
    excerpt: "Comprehensive list of scholarships available for engineering students in India.",
    content: "Financial constraints shouldn't stop you from pursuing engineering. Here are various scholarship opportunities available...",
    author: "Rahul Verma",
    authorImage: "/images/authors/rahul.jpg",
    date: "2024-12-01",
    category: "Scholarships",
    tags: ["Scholarships", "Engineering", "Financial Aid"],
    image: "/images/blogs/scholarships.jpg",
    readTime: "6 min read",
    views: 1420,
    featured: false
  },
  {
    id: 8,
    title: "CAT 2024: Preparation Strategy and Tips",
    slug: "cat-2024-preparation-strategy",
    excerpt: "Expert tips and strategies to crack CAT 2024 and get into top IIMs.",
    content: "CAT is the most sought-after MBA entrance exam in India. Here's a comprehensive preparation strategy to help you succeed...",
    author: "Ananya Krishnan",
    authorImage: "/images/authors/ananya.jpg",
    date: "2024-11-28",
    category: "MBA",
    tags: ["CAT", "MBA", "IIM", "Entrance Exam"],
    image: "/images/blogs/cat-preparation.jpg",
    readTime: "10 min read",
    views: 1780,
    featured: false
  },
  {
    id: 9,
    title: "Career Options After B.Tech: Beyond Software Engineering",
    slug: "career-options-after-btech",
    excerpt: "Explore diverse career paths available for B.Tech graduates beyond traditional software roles.",
    content: "B.Tech opens doors to various career opportunities. Let's explore options beyond the conventional software engineering path...",
    author: "Karthik Menon",
    authorImage: "/images/authors/karthik.jpg",
    date: "2024-11-25",
    category: "Career Guidance",
    tags: ["B.Tech", "Career", "Engineering"],
    image: "/images/blogs/career-options.jpg",
    readTime: "8 min read",
    views: 1340,
    featured: false
  },
  {
    id: 11,
    title: "Top MBA Colleges in India: Complete Rankings 2024",
    slug: "top-mba-colleges-india-2024",
    excerpt: "Comprehensive guide to the best MBA colleges in India with rankings, fees, and placement details.",
    content: "MBA education in India has grown tremendously. Here's a detailed analysis of top MBA colleges including IIMs, FMS, XLRI, and other premier institutes...",
    author: "Sanjay Mehta",
    authorImage: "/images/authors/sanjay.jpg",
    date: "2024-11-20",
    category: "MBA",
    tags: ["MBA", "IIM", "Rankings", "Business School"],
    image: "/images/blogs/mba-colleges.jpg",
    readTime: "15 min read",
    views: 2450,
    featured: false
  },
  {
    id: 12,
    title: "GATE 2024: Subject-wise Preparation Tips",
    slug: "gate-2024-preparation-tips",
    excerpt: "Expert strategies for GATE preparation across different engineering streams.",
    content: "GATE is crucial for M.Tech admissions and PSU jobs. Here are subject-wise preparation strategies for Computer Science, Mechanical, Electrical, and other branches...",
    author: "Arun Kumar",
    authorImage: "/images/authors/arun.jpg",
    date: "2024-11-18",
    category: "Engineering",
    tags: ["GATE", "M.Tech", "Engineering", "PSU"],
    image: "/images/blogs/gate-prep.jpg",
    readTime: "11 min read",
    views: 1680,
    featured: false
  },
  {
    id: 13,
    title: "Internship Guide for Engineering Students",
    slug: "internship-guide-engineering-students",
    excerpt: "How to find, apply, and excel in engineering internships during college.",
    content: "Internships are crucial for building practical skills and getting job offers. This guide covers how to find internships, prepare for interviews, and make the most of your experience...",
    author: "Pooja Desai",
    authorImage: "/images/authors/pooja.jpg",
    date: "2024-11-15",
    category: "Career Guidance",
    tags: ["Internship", "Engineering", "Career", "Skills"],
    image: "/images/blogs/internship-guide.jpg",
    readTime: "9 min read",
    views: 1520,
    featured: false
  },
  {
    id: 14,
    title: "AIIMS vs JIPMER: Which Medical College is Better?",
    slug: "aiims-vs-jipmer-comparison",
    excerpt: "Detailed comparison of AIIMS and JIPMER for aspiring medical students.",
    content: "Both AIIMS and JIPMER are premier medical institutes in India. Let's compare them on various parameters including infrastructure, faculty, research opportunities, and placements...",
    author: "Dr. Suresh Patel",
    authorImage: "/images/authors/suresh.jpg",
    date: "2024-11-12",
    category: "Medical",
    tags: ["AIIMS", "JIPMER", "Medical", "MBBS"],
    image: "/images/blogs/aiims-jipmer.jpg",
    readTime: "10 min read",
    views: 1890,
    featured: false
  },
  {
    id: 15,
    title: "Coding Interview Preparation: Complete Roadmap",
    slug: "coding-interview-preparation-roadmap",
    excerpt: "Step-by-step guide to prepare for coding interviews at top tech companies.",
    content: "Landing a job at FAANG or top tech companies requires solid coding interview preparation. Here's a comprehensive roadmap covering data structures, algorithms, and problem-solving strategies...",
    author: "Rohan Sharma",
    authorImage: "/images/authors/rohan.jpg",
    date: "2024-11-10",
    category: "Career Guidance",
    tags: ["Coding", "Interview", "Tech Jobs", "Programming"],
    image: "/images/blogs/coding-interview.jpg",
    readTime: "14 min read",
    views: 2780,
    featured: false
  },
  {
    id: 16,
    title: "Government Job Opportunities for Engineers",
    slug: "government-jobs-for-engineers",
    excerpt: "Explore various government job options available for engineering graduates in India.",
    content: "Engineering graduates have numerous government job opportunities through UPSC, SSC, PSUs, and state services. Here's a complete guide to these career paths...",
    author: "Manoj Singh",
    authorImage: "/images/authors/manoj.jpg",
    date: "2024-11-08",
    category: "Career Guidance",
    tags: ["Government Jobs", "Engineering", "PSU", "UPSC"],
    image: "/images/blogs/govt-jobs.jpg",
    readTime: "10 min read",
    views: 1650,
    featured: false
  },
  {
    id: 17,
    title: "CLAT 2024: Law Entrance Exam Preparation Guide",
    slug: "clat-2024-preparation-guide",
    excerpt: "Complete guide to crack CLAT and get into top National Law Universities.",
    content: "CLAT is the gateway to premier law schools in India. This comprehensive guide covers exam pattern, syllabus, preparation strategy, and recommended resources...",
    author: "Adv. Priya Nair",
    authorImage: "/images/authors/priya-nair.jpg",
    date: "2024-11-05",
    category: "Law",
    tags: ["CLAT", "Law", "NLU", "Entrance Exam"],
    image: "/images/blogs/clat-prep.jpg",
    readTime: "12 min read",
    views: 1420,
    featured: false
  },
  {
    id: 18,
    title: "Data Science Career Path: Skills and Opportunities",
    slug: "data-science-career-path",
    excerpt: "Everything you need to know about building a career in data science.",
    content: "Data Science is one of the hottest career fields today. Learn about required skills, certifications, job roles, and how to break into this lucrative field...",
    author: "Kavya Reddy",
    authorImage: "/images/authors/kavya.jpg",
    date: "2024-11-02",
    category: "Career Guidance",
    tags: ["Data Science", "Career", "AI", "Analytics"],
    image: "/images/blogs/data-science.jpg",
    readTime: "13 min read",
    views: 2340,
    featured: false
  },
  {
    id: 19,
    title: "Hostel Life in Engineering Colleges: What to Expect",
    slug: "hostel-life-engineering-colleges",
    excerpt: "A realistic guide to hostel life, facilities, and experiences in engineering colleges.",
    content: "Hostel life is an integral part of the college experience. Here's what you can expect from hostel facilities, mess food, roommates, and campus life at engineering colleges...",
    author: "Arjun Malhotra",
    authorImage: "/images/authors/arjun.jpg",
    date: "2024-10-30",
    category: "Student Life",
    tags: ["Hostel", "College Life", "Engineering", "Campus"],
    image: "/images/blogs/hostel-life.jpg",
    readTime: "8 min read",
    views: 1180,
    featured: false
  },
  {
    id: 20,
    title: "Pharmacy Career Options in India",
    slug: "pharmacy-career-options-india",
    excerpt: "Explore diverse career paths available for pharmacy graduates.",
    content: "Pharmacy offers various career opportunities beyond traditional retail. Discover options in clinical pharmacy, pharmaceutical research, regulatory affairs, and more...",
    author: "Dr. Lakshmi Iyer",
    authorImage: "/images/authors/lakshmi.jpg",
    date: "2024-10-28",
    category: "Medical",
    tags: ["Pharmacy", "Career", "Healthcare", "B.Pharm"],
    image: "/images/blogs/pharmacy-career.jpg",
    readTime: "9 min read",
    views: 1290,
    featured: false
  },
  {
    id: 21,
    title: "Time Management Tips for College Students",
    slug: "time-management-tips-students",
    excerpt: "Effective strategies to balance academics, extracurriculars, and personal life.",
    content: "College life can be overwhelming with classes, assignments, projects, and social activities. Here are proven time management techniques to excel in all areas...",
    author: "Ritu Kapoor",
    authorImage: "/images/authors/ritu.jpg",
    date: "2024-10-25",
    category: "Student Life",
    tags: ["Time Management", "Productivity", "Study Tips", "College"],
    image: "/images/blogs/time-management.jpg",
    readTime: "7 min read",
    views: 1560,
    featured: false
  },
  {
    id: 22,
    title: "Architecture Colleges in India: Top Choices",
    slug: "architecture-colleges-india",
    excerpt: "Guide to the best architecture colleges and NATA preparation.",
    content: "Architecture is a creative and rewarding career. Explore top architecture colleges in India, NATA exam details, and what to expect from architecture education...",
    author: "Ar. Sameer Khan",
    authorImage: "/images/authors/sameer.jpg",
    date: "2024-10-22",
    category: "Architecture",
    tags: ["Architecture", "NATA", "Design", "College"],
    image: "/images/blogs/architecture.jpg",
    readTime: "11 min read",
    views: 980,
    featured: false
  },
  {
    id: 23,
    title: "Resume Building Guide for Freshers",
    slug: "resume-building-guide-freshers",
    excerpt: "Create a professional resume that gets you noticed by recruiters.",
    content: "Your resume is your first impression on potential employers. Learn how to craft an effective resume highlighting your skills, projects, and achievements as a fresher...",
    author: "Deepak Joshi",
    authorImage: "/images/authors/deepak.jpg",
    date: "2024-10-20",
    category: "Career Guidance",
    tags: ["Resume", "Job Search", "Career", "Freshers"],
    image: "/images/blogs/resume-building.jpg",
    readTime: "8 min read",
    views: 2120,
    featured: false
  },
  {
    id: 24,
    title: "Mental Health and Wellness for Students",
    slug: "mental-health-wellness-students",
    excerpt: "Essential tips for maintaining mental health during academic pressure.",
    content: "Academic pressure can take a toll on mental health. Learn about stress management, seeking help, maintaining work-life balance, and building resilience...",
    author: "Dr. Anjali Verma",
    authorImage: "/images/authors/anjali.jpg",
    date: "2024-10-18",
    category: "Student Life",
    tags: ["Mental Health", "Wellness", "Stress", "College Life"],
    image: "/images/blogs/mental-health.jpg",
    readTime: "10 min read",
    views: 1840,
    featured: false
  }
];

/**
 * Simulate network delay
 */
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Get all blog posts with pagination
 * @param {number} page - Page number
 * @param {number} limit - Posts per page
 * @param {string} category - Filter by category (optional)
 */
export const getBlogPosts = async (page = 1, limit = 9, category = null) => {
  await delay(400);
  
  let filteredBlogs = [...MOCK_BLOGS];
  
  // Filter by category if provided
  if (category) {
    filteredBlogs = filteredBlogs.filter(blog => blog.category === category);
  }
  
  // Sort by date (newest first)
  filteredBlogs.sort((a, b) => new Date(b.date) - new Date(a.date));
  
  // Paginate
  const startIndex = (page - 1) * limit;
  const endIndex = startIndex + limit;
  const paginatedBlogs = filteredBlogs.slice(startIndex, endIndex);
  
  return {
    posts: paginatedBlogs,
    currentPage: page,
    totalPages: Math.ceil(filteredBlogs.length / limit),
    totalPosts: filteredBlogs.length,
    hasMore: endIndex < filteredBlogs.length
  };
};

/**
 * Get blog post by ID or slug
 * @param {number|string} identifier - Blog ID or slug
 */
export const getBlogPostById = async (identifier) => {
  await delay(300);
  
  const post = MOCK_BLOGS.find(
    blog => blog.id === identifier || blog.slug === identifier
  );
  
  if (!post) {
    throw new Error('Blog post not found');
  }
  
  return post;
};

/**
 * Get related blog posts
 * @param {number} postId - Current post ID
 * @param {number} limit - Number of related posts
 */
export const getRelatedPosts = async (postId, limit = 3) => {
  await delay(300);
  
  const currentPost = MOCK_BLOGS.find(blog => blog.id === postId);
  
  if (!currentPost) {
    return [];
  }
  
  // Find posts with same category or tags
  const related = MOCK_BLOGS.filter(blog => {
    if (blog.id === postId) return false;
    
    // Same category
    if (blog.category === currentPost.category) return true;
    
    // Shared tags
    const sharedTags = blog.tags.filter(tag => currentPost.tags.includes(tag));
    return sharedTags.length > 0;
  });
  
  // Sort by relevance (same category first, then by date)
  related.sort((a, b) => {
    if (a.category === currentPost.category && b.category !== currentPost.category) return -1;
    if (a.category !== currentPost.category && b.category === currentPost.category) return 1;
    return new Date(b.date) - new Date(a.date);
  });
  
  return related.slice(0, limit);
};

/**
 * Get featured blog posts
 */
export const getFeaturedPosts = async () => {
  await delay(300);
  
  const featured = MOCK_BLOGS.filter(blog => blog.featured);
  
  return featured.sort((a, b) => new Date(b.date) - new Date(a.date));
};

/**
 * Get all unique categories
 */
export const getBlogCategories = () => {
  const categories = [...new Set(MOCK_BLOGS.map(blog => blog.category))];
  return categories.sort();
};

/**
 * Get all unique tags
 */
export const getBlogTags = () => {
  const tags = new Set();
  MOCK_BLOGS.forEach(blog => {
    blog.tags.forEach(tag => tags.add(tag));
  });
  return Array.from(tags).sort();
};

/**
 * Search blog posts
 * @param {string} query - Search query
 */
export const searchBlogPosts = async (query) => {
  await delay(400);
  
  const searchLower = query.toLowerCase();
  
  const results = MOCK_BLOGS.filter(blog =>
    blog.title.toLowerCase().includes(searchLower) ||
    blog.excerpt.toLowerCase().includes(searchLower) ||
    blog.tags.some(tag => tag.toLowerCase().includes(searchLower)) ||
    blog.category.toLowerCase().includes(searchLower)
  );
  
  return results.sort((a, b) => new Date(b.date) - new Date(a.date));
};
